import React, { useState } from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import ImageCarousel from "../components/ImageCarousel";
import ExplorePlaces from "../components/ExplorePlaces";
import { useParams } from "react-router-dom";
import { useProductData } from "../hooks/useProductData";
import { Spin } from "antd";
import TourTabsDynamic from "../components/TourTabsDynamic";
import ExploreTopMustDoThings from "../components/ExploreTopMustDoThings";
import SpatialOffers from "../components/SpatialOffers";
import ExploreMore from "../components/ExploreMore";


const SubCategoryPage = () => {
  const { subSlug, category } = useParams();
  // Use whichever parameter exists
  const slug = subSlug || category;
  const { product, loading, error } = useProductData(slug);
  const [selectedTour, setSelectedTour] = useState(null);

  // Show loading spinner
  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <Spin size="large" tip="Loading product..." />
      </div>
    );
  }

  // Show errors or missing product
  if (error) return <p className="text-red-500">{error}</p>;
  if (!product) return <p>No product found.</p>;

  // ✅ FIX: Use direct fields (not product.attributes)
  const subProducts = product.sub_products || [];

  const slides =
    subProducts.map((sub) => ({
      id: sub.id,
      title: sub.title || "Untitled",
      img:
        sub.sub_product_image ||
        "https://via.placeholder.com/240x160?text=No+Image",
      rating: sub.rating,
      views: sub.views,
      banner: sub.summary || "Explore more with this package!",
      slug: `${subSlug}/${sub.slug}` || "",
    })) || [];
  return (
    <>
      {/* <section className="bg-lightSky border border-solid border-[#CCE1F9] pt-6 pb-8">
        <ImageCarousel slides={tours} onSelect={setSelectedTour} />
      </section> */}

      <section className="bg-lightSky border border-solid border-[#CCE1F9] pt-6 pb-6">
        {slides.length > 0 ? (
          <ImageCarousel
            slides={slides}
            onSelect={setSelectedTour}
            parentTitle={`All Efficient ${product.name} Package`}
          />
        ) : (
          <p className="text-center py-6 text-gray-500">
            No sub products found.
          </p>
        )}
      </section>
      {/* Special</span> Offers */}
      {/* <section className="pt-10 py-4 px-4 lg:px-0">
        <HoverCards />
      </section> */}

      <section className="py-4 px-4 lg:px-0">
        <TourTabsDynamic slides={slides} slug={slug} />
      </section>
      {/* 
      <section className="py-4 px-4 lg:px-0">
        <div className="flex justify-center align-middle items-center mb-6 font-medium">
          <div>
            <Title
              className="!font-medium !text-danger !text-2xl !mb-1 text-center"
              level={2}
            >
              <span className="text-primary">
                Explore Top Must do things in{" "}
              </span>{" "}
              Dubai
            </Title>
            <Paragraph className="!mb-0">
              Culture, nature, thrills, and record-breaking experiences
            </Paragraph>
          </div>
        </div>
        <div className="container">
          <Row gutter={[30, 30]}>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
          </Row>

          <Row gutter={[30, 30]} className="mt-8">
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
            <Col lg={12} xs={24}>
              <TourCard />
            </Col>
          </Row>
        </div>
        <Flex justify="center" align="center" className="mt-10">
          <Button
            size="middle"
            type="default"
            className="font-semibold w-60 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-danger rounded-lg"
          >
            See More
          </Button>
        </Flex>
      </section> */}

      <section className="py-4 px-4 lg:px-0">
        <ExploreTopMustDoThings />
      </section>

      {/* <section className="py-4 px-4 lg:px-0">
        <FAQAccordion />
      </section> */}
      {/* Family </span>  Fun */}
      {/* <section className="py-4 px-4 lg:px-0">
        <ExploreAttractions />
      </section> */}

      <section className="py-4 px-4 lg:px-0">
        <ExploreMore />
      </section>

      {/* <section className="py-6">
        <ReviewSlider />
      </section> */}

      <section className="py-4 px-4 lg:px-0">
        <div className="container">
          <ExplorePlaces />
        </div>
      </section>

      <section className="py-4 px-4 lg:px-0">
        <div className="container">
          <div className="flex justify-between align-middle items-center mb-6">
            <h2 className="font-medium text-danger text-2xl">
              <span className="text-primary">Special</span> Offers
            </h2>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>
          <SpatialOffers />
        </div>
      </section>
    </>
  );
};

export default SubCategoryPage;
